import columns from '../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    ExternalConsignmentLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'consignmentId').withWidth(150)),
        new DateTimeColumn('Completion date', 'completionDate'),
        new TextColumn('Carrier', 'carrier'),
        new NonZeroNumberColumn('Transport legs', 'transportLegs'),
      ],
    },
    {
      Header: 'Origin',
      columns: [
        new TextColumn('Origin location', 'origin.originLocation'),
        new NonZeroNumberColumn('CARDIT', 'origin.cardit'),
        new NonZeroNumberColumn('RESDIT 74', 'origin.resdit74'),
        new NonZeroNumberColumn('RESDIT 82', 'origin.resdit82'),
        new NonZeroNumberColumn('RESDIT 57', 'origin.resdit57'),
        new NonZeroNumberColumn('RESDIT 6', 'origin.resdit6'),
        new NonZeroNumberColumn('RESDIT 24', 'origin.resdit24'),
      ],
    },
    {
      Header: 'Transport leg 2',
      columns: [
        new TextColumn('Origin location', 'transportLeg2.originLocation'),
        new NonZeroNumberColumn('RESDIT 14', 'transportLeg2.resdit14'),
        new NonZeroNumberColumn('RESDIT 40', 'transportLeg2.resdit40'),
        new NonZeroNumberColumn('RESDIT 42', 'transportLeg2.resdit42'),
        new NonZeroNumberColumn('RESDIT 43', 'transportLeg2.resdit43'),
        new NonZeroNumberColumn('RESDIT 24', 'transportLeg2.resdit24'),
      ],
    },
    {
      Header: 'Destination',
      columns: [
        new TextColumn('Destination location', 'destination.destinationLocation'),
        new NonZeroNumberColumn('RESDIT 14', 'destination.resdit14'),
        new NonZeroNumberColumn('RESDIT 23', 'destination.resdit23'),
        new NonZeroNumberColumn('RESDIT 21', 'destination.resdit21'),
        new TextColumn('RESDIT other', 'destination.resditOther'),
      ],
    },
  ];
};
